{
    "order": {
        "show": {
            "greeting": {
                "introduction": "Bedankt dat u ervoor gekozen heeft om de Wet'ringdempers te steunen met uw bestelling!"
            },
            "stateAlert": {
                "refunded": "Je bestelling is terugbetaald. We komen niet meer langs. Is dit een foutje? Neem dan contact met ons op via oliebollen@wetringdempers.nl.",
                "deleted": "Je bestelling is geannuleerd. Is dit een foutje? Neem dan contact met ons op via oliebollen@wetringdempers.nl."
            }
        }
    }
}
